module.exports = __webpack_public_path__ + "media/mayasaddition.6eb8f665.mp4";